import { refreshToken } from "./nimble";

let token = null;
let refAuthID = null;
let clientNameUrlVersion = null;
let refreshTimer = null;

export function setToken(newToken, minutesToExpire, newRefAuthID, version, isRefresh = false) {
  token = newToken;
  refAuthID = newRefAuthID;
  clientNameUrlVersion = version;
  if (minutesToExpire && isRefresh) {
    scheduleRefresh(minutesToExpire);
  }
}

export function getToken() {
  return token;
}

function scheduleRefresh(minutesToExpire) {
  if (refreshTimer) clearTimeout(refreshTimer);

  const refreshInMs = Math.max((minutesToExpire - 2) * 60 * 1000, 0);

  refreshTimer = setTimeout(async () => {
    const result = await refreshToken(token, refAuthID, clientNameUrlVersion);

    if (result) {
      setToken(result.token, result.minutesToExpire, result.refAuthID, clientNameUrlVersion, true);
    }
  }, refreshInMs);
}
